
import { Component, Vue, Prop } from "vue-property-decorator";
import { objAny } from "@/common/common-interface";
import { addStopReason } from "@/api/api-basic";
import i18n from "@/config/i18n";
@Component({
  components: {}
})
export default class PiaddStopReason extends Vue {
  @Prop({
    default: () => {
      return [];
    }
  })
  private responsibilityTypeList!: object[];
  private formInline: objAny = {
    formList: []
  };
  private formInlineJson: objAny = {
    stopCode: "",
    stopName: "",
    responsibilityType: ""
  };
  private dutyList: object[] = [];
  private upgradeTime = "";
  private loading = false;
  private modalShow = false;
  private modalTitle = i18n.t("stopReason.add");
  private formObj: objAny = {};
  private ruleInline: objAny = {
    stopCode: [
      {
        required: true,
        message: i18n.t("stopReason.stopCodePl"),
        trigger: "blur"
      }
    ],
    stopName: [
      {
        required: true,
        message: i18n.t("stopReason.stopNamePl"),
        trigger: "blur"
      }
    ],
    responsibilityType: [
      {
        required: true,
        message: i18n.t("stopReason.responsibilityTypePl"),
        trigger: "change"
        // type: "number"
      }
    ]
  };
  private isAdd = false;
  private stopCode = "";
  public open() {
    this.$nextTick(() => {
      this.formObj = this.$refs["formInline"];
    });
    this.modalShow = true;

    this.formInline.formList = [];
    this.addRow();
  }
  public addRow() {
    const formInlineJson: objAny = JSON.parse(
      JSON.stringify(this.formInlineJson)
    );
    this.formInline.formList.push(formInlineJson);
  }
  public removeRow(index: number) {
    this.formInline.formList.splice(index, 1);
  }
  public handleSubmit() {
    this.formObj.validate((valid: boolean) => {
      if (valid) {
        this.submitData();
      }
    });
  }
  async submitData(): Promise<void> {
    this.loading = true;
    const ret = await addStopReason(this.formInline.formList);
    if (ret.status === this.$config.apiStatus) {
      this.$Message.success(i18n.t("addSuccess"));
      this.$emit("success");
      this.modalShow = false;
    }
    this.loading = false;
  }
}
